<h6 class="tw-mb-2 tw-text-red-600" *ngIf="(!contentShare.id && contentShare.precondition)">
  <span [innerHTML]="'lang.contentShare.createPrecondition'|translate: {share: contentShare.precondition.name} | truncate:120"></span>
</h6>
<div class="tw-flex mb-4 tw-mr-4">
  <div class="tw-w-1/3 mr-4">
    <h4 class="tw-mb-4">{{ 'lang.globals.settings'|translate }}</h4>
    <form [formGroup]="form">
      <div class="form-group tw-mb-2 validateMe">
        <label class="form-label" for="Title">{{ 'lang.globals.name' | translate }}<span class="red">*</span></label>
        <input sbAutofocus type="text" id="Title" class="form-control" formControlName="Name">
        <span class="form-text text-muted">{{ 'lang.globals.nameDescription' | translate }}</span>
        <div *ngIf="Name.touched && Name.errors?.required"
             class="alert alert-danger">{{ 'lang.globals.nameWarning' | translate }}
        </div>
      </div>
      <div class="form-group tw-mb-8 validateMe">
        <label class="form-label" for="Description">{{ 'lang.globals.description' | translate }}</label>
        <input type="text" id="Description" class="form-control" formControlName="Description">
        <span class="form-text text-muted">{{ 'lang.globals.descriptionDescription' | translate }}</span>
        <div *ngIf="Description.touched && Description.errors?.required"
             class="alert alert-danger">{{ 'lang.globals.description' | translate }}
        </div>
      </div>
      <div class="form-group tw-mb-8">
        <label class="form-check-label" for="PercentageBase">{{ 'lang.globals.basedOn' | translate }}</label>
        <div id="PercentageBase" class="tw-w-full">
          <div *ngFor="let base of distributionBasis" class="form-check">
            <input type="radio" class="form-check-input" name="PercentageBase" id="{{base}}" value="{{base}}"
                   [checked]="base === contentShare.quotaDistributionBasis" (change)="contentShare.quotaDistributionBasis = base" />
            <label for="{{base}}" class="form-check-label tw-ml-3">{{ 'lang.globals.' + base?.toLowerCase() | translate }}</label>
          </div>
          <span class="form-text text-muted">{{ 'lang.contentShare.basedDescription' | translate }}
          </span>
        </div>
      </div>
      <div class="form-group tw-mb-2">
        <sb-local-date-time-input (modelChange)="localDateTimeInputFrom($event)" [kind]="'RANGE_START'"
                                  [seconds]="false"
                                  [title]="translate.instant('lang.globals.startTime')"
                                  class="w-100"
                                  formControlName="From"
                                  id="From">
        </sb-local-date-time-input>
        <div *ngIf="form.touched && form.errors?.endDateAfterStartDate" class="alert alert-danger">
          {{ 'lang.commercialEdit.startTimeCorrection' | translate }}
        </div>

      </div>
      <div class="form-group tw-mb-8">
        <sb-local-date-time-input (modelChange)="localDateTimeInputTill($event)" [kind]="'RANGE_END'"
                                  [minDate]="From.value"
                                  [seconds]="false" [title]="translate.instant('lang.globals.dueTime')"
                                  class="w-100"
                                  formControlName="Till"
                                  id="Till"></sb-local-date-time-input>
        <div *ngIf="form.touched && form.errors?.endDateAfterStartDate" class="alert alert-danger">
          {{ 'lang.commercialEdit.dueTimeCorrection' | translate }}
        </div>
      </div>
      <div class="form-group tw-mb-2">
        <div class="tw-w-full">
          <label class="form-label" for="TimeCull">{{ 'lang.globals.timeCull' | translate }}</label>
          <sb-comp-selection [icon]="'calendar'"
                             id="TimeCull"
                             [display]="contentShare.timeCull"
                             [hideCreate]="true"
                             [emptyString]="'lang.globals.noSelection' | translate"
                             (deleteClicked)="contentShare.timeCull = null"
                             (selectClicked)="selectFilter('TimeCull')"></sb-comp-selection>
        </div>
      </div>
      <div class="form-group tw-mb-2">
        <div class="tw-w-full">
          <label class="form-label" for="PlayerCull">{{ 'lang.globals.playerCull' | translate }}</label>
          <sb-comp-selection [icon]="'player'"
                             id="PlayerCull"
                             [display]="contentShare.playerCull"
                             [hideCreate]="true"
                             [emptyString]="'lang.globals.noSelection' | translate"
                             (deleteClicked)="contentShare.playerCull = null"
                             (selectClicked)="selectFilter('PlayerCull')"></sb-comp-selection>
        </div>
      </div>
      <div class="form-group tw-mb-2">
        <div class="tw-w-full">
          <label class="form-label" for="GeoCull">{{ 'lang.globals.geoCull' | translate }}</label>
          <sb-comp-selection [icon]="'globe'"
                             [display]="contentShare.geoCull"
                             id="GeoCull"
                             [hideCreate]="true"
                             [emptyString]="'lang.globals.noSelection' | translate"
                             (deleteClicked)="contentShare.geoCull = null"
                             (selectClicked)="selectFilter('GeoCull')"></sb-comp-selection>
        </div>
      </div>
    </form>
  </div>
  <div class="tw-w-2/3 ml-4 tw-mr-2">
    <sb-comp-quotas [quotas]="contentShare?.quotas"></sb-comp-quotas>
  </div>
</div>
<div class="d-flex justify-content-between tw-mr-4">
  <button type="button" (click)="contentShareChanged.emit(null)"
          class="btn btn-default btn-lg">{{ 'lang.globals.cancel' | translate }}
  </button>
  <button type="submit" (click)="updateContentShare()" [disabled]="checkPercentage() || disableSubmit || !form.valid "
          class="btn btn-success btn-lg">{{ 'lang.globals.submit' | translate }}
  </button>
</div>
